const $$splitComponentImporter = () => import('/app/src/routes/auth/logout.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/auth/logout")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async () => {
    if (import.meta.env.SSR) {
      const {
        deleteCookie
      } = await import("@/lib/start-server");
      deleteCookie("EGDATA_AUTH", {
        secure: true,
        path: "/",
        domain: import.meta.env.PROD ? ".egdata.app" : "localhost"
      });
    }
    throw redirect({
      to: "/{-$locale}"
    });
  }
});